<!-- TODO: definire il testo -->
<app-toolkit-page-title title="Contatti"></app-toolkit-page-title>
<div class="row">
    <div class="col-12 blocco-contatti">
        <div class="testo-contatti">
            <b>Marina Credali</b> <br>
            TERRITORIO E SISTEMI VERDI - ASSETTO IDROGEOLOGICO, RETICOLI E DEMANIO IDRICO<br>
            Tel. 02 6765 4026 - email <a href="mailto:marina_credali@regione.lombardia.it">marina_credali@regione.lombardia.it</a><br>
            <b>Luca Giuseppe Rossi</b> <br>
            TERRITORIO E SISTEMI VERDI - ASSETTO IDROGEOLOGICO, RETICOLI E DEMANIO IDRICO<br>
            Tel. 02 6765 3026 - email <a href="mailto:luca_giuseppe_rossi@regione.lombardia.it">luca_giuseppe_rossi@regione.lombardia.it</a>
        </div>
    </div>
</div>

<div class="d-flex justify-content-start mb-3">
    <div class="linea-meta"></div>
</div>

<div class="row">
    <div class="col-12 blocco-contatti">
        <div class="testo-contatti">
           Per problemi di carattere tecnico (informazioni o segnalazioni di malfunzionamenti relativi al gestionale web delle ODS o richieste di supporto tecnico relativo al viewer pubblico delle ODS) scrivere a:<br>
        <a href="mailto:ods_assistenza@ariaspa.it">ods_assistenza@ariaspa.it</a>
        </div>
    </div>

</div>